import axios from "./axiosInstance";

const orderAPI = {
  homepage: (payload) => axios.post("orders/dashboard", payload),

  getLastOrder: () => axios.get("orders/last-order"),

  list: (params) => axios.get("/orders", { params }),

  details: (payload) => axios.post("/orders/get-order-details", payload),

  updateStatus: (payload) => axios.post("/orders/update-status", payload),

  addShipmentDetails: (payload) => axios.post("/orders/update-shipment-details", payload),

  exportOrders: (params) => axios.get("/orders/export", { params, responseType: "blob"}),
  
};

export default orderAPI;
